import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import { Dayjs } from "dayjs";
import { SxProps } from "@mui/material";

interface TimepickerProps {
  value?: Dayjs | null;
  label: string;
  onChange?: (value: Dayjs | null) => void;
  sx?: SxProps<object>;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  disableWrite?: boolean;
}

const Timepicker: React.FC<TimepickerProps> = ({
  value,
  label,
  onChange,
  sx,
  error,
  helperText,
  required = false,
  disabled = false,
  disableWrite = false,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          minWidth: 180,
          display: "flex",
          flexGrow: 1,
          maxWidth: "100%",
          ...sx,
        }}
      >
        <FormControl fullWidth error={error}>
          <MuiTimePicker
            value={value}
            label={label}
            onChange={onChange}
            ampm
            slotProps={{
              textField: {
                error: error,
                helperText: error ? helperText : "",
                required: required,
              },
              field: {
                readOnly: disableWrite,
              },
            }}
            disabled={disabled}
          />
        </FormControl>
      </Box>
    </LocalizationProvider>
  );
};

export default Timepicker;
